"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceRedirectStatus = void 0;
var WorkspaceRedirectStatus;
(function (WorkspaceRedirectStatus) {
    WorkspaceRedirectStatus["NONE"] = "None";
    WorkspaceRedirectStatus["COMPANY_NOT_FOUND"] = "CompanyNotFound";
    WorkspaceRedirectStatus["WORKSPACE_NOT_FOUND"] = "WorkspaceNotFound";
    WorkspaceRedirectStatus["COMPANY_MEMBER_NOT_FOUND"] = "CompanyMemberNotFound";
    WorkspaceRedirectStatus["COMPANY_MEMBER_HAS_NOT_ENOUGH_RIGHTS"] = "CompanyMemberHasNotEnoughRights";
    WorkspaceRedirectStatus["COMPANY_IN_INVALID_STATE"] = "CompanyInInvalidState";
    WorkspaceRedirectStatus["WORKSPACE_IS_MARKED_FOR_DELETION"] = "WorkspaceIsMarkedForDeletion";
    WorkspaceRedirectStatus["USER_DID_NOT_ACCEPT_LEGAL_DOCUMENTS"] = "UserDidNotAcceptLegalDocuments";
    WorkspaceRedirectStatus["WORKSPACE_IS_IN_MAINTENANCE"] = "WorkspaceIsInMaintenance";
    WorkspaceRedirectStatus["CANNOT_REDIRECT_USER_WORKSPACE"] = "CannotRedirectUserWorkspace";
    WorkspaceRedirectStatus["WORKSPACE_IS_CREATING"] = "WorkspaceIsCreating";
    WorkspaceRedirectStatus["ADMIN_NOT_ADDED_YET"] = "AdminNotAddedYet";
    WorkspaceRedirectStatus["REDIRECT_ALLOWED"] = "RedirectAllowed";
})(WorkspaceRedirectStatus || (exports.WorkspaceRedirectStatus = WorkspaceRedirectStatus = {}));
